export const UPCHARGE = 'upcharge'
const DISCOUNT = 'discount'

export const priceDeltaSignOptions = [
  { name: '+ Upcharge', value: UPCHARGE },
  { name: '- Discount', value: DISCOUNT }
]

export const formatPriceDelta = price => {
  if (!price?.cents) return ''
  return `${price.cents > 0 ? '+' : '-'}${price.format.replace('-', '')}`
}

export const splitPriceCents = cents => ({
  sign: cents < 0 ? DISCOUNT : UPCHARGE,
  amount: (Math.abs(cents || 0) / 100).toFixed(2)
})

export const priceCentsFrom = (sign, amount) => {
  const cents = Math.round(Number(amount) * 100)
  return sign === DISCOUNT && cents ? -cents : cents
}
